export const maxAllowedItemsInOrder = 999;

export const FETCH_ABORTED = 'aborted';
